"use client";
import { forwardRef as e } from "react";
import { jsx as t } from "react/jsx-runtime";
import * as n from "@radix-ui/react-toggle-group";
//#region src/components/atoms/ToggleGroup/ToggleGroup.tsx
var r = e((e, r) => /* @__PURE__ */ t(n.Root, {
	"data-slot": "toggle-group",
	...e,
	ref: r
}));
r.displayName = "ToggleGroupRoot";
var i = e((e, r) => /* @__PURE__ */ t(n.Item, {
	"data-slot": "toggle-group-item",
	...e,
	ref: r
}));
i.displayName = "ToggleGroupItem";
//#endregion
export { i as ToggleGroupItem, r as ToggleGroupRoot };
